import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import EnglishTranslate from "../../assets/locales/english/translation.json";
import HindiTranslate from "../../assets/locales/hindi/translation.json";

const resources = {
  english: { translation: EnglishTranslate },
  hindi: { translation: HindiTranslate },
};
i18n.use(initReactI18next).init({
  resources,
  lng: "hindi",
  keySeparator: false,
  fallbackLng: "english",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
